import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../../shared-module/shared.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { FlexLayoutModule } from '@angular/flex-layout';
import { OverviewComponent } from './overview/overview.component';
import { AddModule } from './add/add.module';
import { CustomMaterialModule } from '../../core/material.module';
import { OverviewListingsComponent } from './overview-listings/overview-listings.component';
import { OverviewSingleBlogListingComponent } from './overview-single-blog-listing/overview-single-blog-listing.component';
import { EditModule } from './edit/edit.module';

export const COMPONENTS = [
  OverviewComponent,
  OverviewListingsComponent,
  OverviewSingleBlogListingComponent,
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    FlexLayoutModule,
    SharedModule,
    TranslateModule,
    AddModule,
    EditModule,
    CustomMaterialModule,
  ],
  declarations: COMPONENTS,
  exports: COMPONENTS,
  providers: [],
  entryComponents: [],
})
export class ComponentsModule {}
